import React from "react";
import {
	Button,
	Modal,
	Select,
	Textfield,
} from "../../../../../components/core";
import { NumericFormat, PatternFormat } from "react-number-format";
import { DOOR_SIZES } from "../../../../../constants/graphql/global-queries";
import { useDispatch, useSelector } from "react-redux";
import { setDoorSizesList } from "../../../../../features/locker-fees/add-user-fees/add-user-fees-slice";
import { useQuery } from "@apollo/client";
import { Dialog } from "primereact/dialog";
export default function ShipoutFeesTable({
	data,
	lockerType,
	userType,
	addedData,
	className,
	handleAddDataItem,
	handleModifyAddedItems,
	handleEditData,
	disabled = false,
}) {
	const dispatch = useDispatch();
	const doorSizes = useQuery(DOOR_SIZES);
	const doorSizesList = useSelector((state) => state.addUserFee.doorSizesList);
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});
	React.useEffect(() => {
		if (doorSizes.data) {
			let tempVar = [];
			doorSizes.data.doorSizes.map((element) => {
				tempVar.push({
					value: element.doorSizeId,
					name: element.doorSize,
				});
			});
			dispatch(setDoorSizesList(tempVar));
		}
	}, [doorSizes.data]);
	return (
		<div className="my-4">
			<div className="bg-primary-primaryYellowLight text-center p-4 border-2 border-gray-400 font-bold text-lg">
				<p>REJECTED/CANCELLED SHIP-OUT FEES</p>
				<p>
					for {lockerType} Locker - {userType} User
				</p>
			</div>
			<table className="w-full border-2 border-gray-400">
				<thead>
					<tr className="bg-primary-primaryYellow h-16">
						<th className="text-left p-2">Door Sizes</th>
						<th className="text-left p-2">Initial Return/Cancellation Fee</th>
						<th className="text-left p-2">Additional Initial Free Hours</th>
						<th className="text-left p-2">
							Overstay charges after Initial Free Hours
						</th>
						<th className="text-left p-2">Max Overstay Charge</th>
					</tr>
				</thead>
				<tbody>
					{data &&
						data.map((data, key) => {
							return (
								<tr className="h-12 even:bg-gray-100 bg-white">
									<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
										<Select
											disabled={disabled}
											name="doorSizeId"
											value={data.doorSizeId}
											items={doorSizesList}
											defaultOption={{
												value: "-1",
												name: "-- Select Door Size -- ",
											}}
											onChange={(e) => handleEditData(e, key)}
										/>
									</td>
									<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
										<div className="flex gap-2">
											<p className="my-auto">P</p>{" "}
											<Textfield
												disabled={disabled}
												name="initialReturnFee"
												value={data.initialReturnFee}
												onChange={(e) => {
													let regex = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;
													if (
														(regex.test(e.target.value) &&
															parseFloat(e.target.value) <= 1000000000) ||
														e.target.value === ""
													) {
														handleEditData(e, key);
													}
												}}
											/>
										</div>
									</td>
									<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
										<div className="flex gap-2">
											<Textfield
												disabled={disabled}
												name="addInitialFreeHours"
												value={data.addInitialFreeHours}
												onChange={(e) => {
													let regex = /^(\d+)?$/;
													if (
														(regex.test(e.target.value) &&
															parseInt(e.target.value) <= 720) ||
														e.target.value === ""
													) {
														handleEditData(e, key);
													}
												}}
											/>{" "}
											<p className="my-auto">hrs</p>
										</div>
									</td>
									<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
										<div className="flex gap-2">
											<p className="my-auto">P</p>{" "}
											<Textfield
												disabled={disabled}
												name="excessFeePerInc"
												value={data.excessFeePerInc}
												onChange={(e) => {
													let regex = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;
													if (
														(regex.test(e.target.value) &&
															parseFloat(e.target.value) <= 1000000000) ||
														e.target.value === ""
													) {
														handleEditData(e, key);
													}
												}}
											/>{" "}
											<p className="my-auto"> / </p>
											<p className="my-auto">every</p>{" "}
											<Textfield
												disabled={disabled}
												name="incByHours"
												value={data.incByHours}
												onChange={(e) => {
													let regex = /^(\d+)?$/;
													if (
														(regex.test(e.target.value) &&
															parseInt(e.target.value) <= 720) ||
														e.target.value === ""
													) {
														handleEditData(e, key);
													}
												}}
											/>
										</div>
									</td>
									<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
										<div className="flex gap-2">
											<p className="my-auto">P</p>{" "}
											<Textfield
												disabled={disabled}
												name="maxOverstayCharge"
												value={data.maxOverstayCharge}
												onChange={(e) => {
													let regex = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;
													if (
														(regex.test(e.target.value) &&
															parseFloat(e.target.value) <= 1000000000) ||
														e.target.value === ""
													) {
														handleEditData(e, key);
													}
												}}
											/>
										</div>
									</td>
								</tr>
							);
						})}

					{addedData &&
						addedData.map((data, key) => {
							return (
								<tr className="h-12 even:bg-gray-100 bg-white">
									<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
										<Select
											items={doorSizesList}
											value={addedData[key].doorSizeId}
											defaultOption={{
												value: "-1",
												name: "-- Select Door Size -- ",
											}}
											name="doorSizeId"
											id={key}
											onChange={(e) => handleModifyAddedItems(e, key)}
										/>
									</td>
									<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
										<div className="flex gap-2">
											<p className="my-auto">P</p>{" "}
											<Textfield
												maxLength={13}
												allowNegative={false}
												allowedDecimalSeparators={["%"]}
												decimalScale={2}
												name="initialReturnFee"
												value={addedData[key].initialReturnFee}
												id={key}
												placeholder="00.00"
												onChange={(e) => {
													let regex = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;
													if (
														(regex.test(e.target.value) &&
															parseFloat(e.target.value) <= 1000000000) ||
														e.target.value === ""
													) {
														handleModifyAddedItems(e, key);
													}
												}}
												customInput={Textfield}
											/>
										</div>
									</td>
									<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
										<div className="flex gap-2">
											<Textfield
												maxLength={3}
												valueIsNumericString
												format="###"
												mask=""
												name="addInitialFreeHours"
												id={key}
												placeholder="XXX"
												value={addedData[key].addInitialFreeHours}
												onChange={(e) => {
													let regex = /^(\d+)?$/;
													if (
														(regex.test(e.target.value) &&
															parseInt(e.target.value) <= 720) ||
														e.target.value === ""
													) {
														handleModifyAddedItems(e, key);
													}
												}}
												customInput={Textfield}
											/>{" "}
											<p className="my-auto">hrs</p>
										</div>
									</td>
									<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
										<div className="flex gap-2">
											<p className="my-auto">P</p>{" "}
											<Textfield
												maxLength={13}
												allowNegative={false}
												allowedDecimalSeparators={["%"]}
												decimalScale={2}
												value={addedData[key].excessFeePerInc}
												placeholder="00.00"
												name="excessFeePerInc"
												id={key}
												onChange={(e) => {
													let regex = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;
													if (
														(regex.test(e.target.value) &&
															parseFloat(e.target.value) <= 1000000000) ||
														e.target.value === ""
													) {
														handleModifyAddedItems(e, key);
													}
												}}
												customInput={Textfield}
											/>{" "}
											<p className="my-auto"> / </p>
											<p className="my-auto">every</p>{" "}
											<Textfield
												maxLength={3}
												valueIsNumericString
												format="###"
												mask=""
												placeholder="XXX"
												value={addedData[key].incByHours}
												name="incByHours"
												id={key}
												onChange={(e) => {
													let regex = /^(\d+)?$/;
													if (
														(regex.test(e.target.value) &&
															parseInt(e.target.value) <= 720) ||
														e.target.value === ""
													) {
														handleModifyAddedItems(e, key);
													}
												}}
												customInput={Textfield}
											/>
										</div>
									</td>
									<td className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2">
										<div className="flex gap-2">
											<p className="my-auto">P</p>{" "}
											<Textfield
												allowNegative={false}
												allowedDecimalSeparators={["%"]}
												decimalScale={2}
												value={addedData[key].maxOverstayCharge}
												placeholder="00.00"
												name="maxOverstayCharge"
												id={key}
												onChange={(e) => {
													let regex = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;
													if (
														(regex.test(e.target.value) &&
															parseFloat(e.target.value) <= 1000000000) ||
														e.target.value === ""
													) {
														handleModifyAddedItems(e, key);
													}
												}}
												customInput={Textfield}
											/>
										</div>
									</td>
								</tr>
							);
						})}
					<tr className="h-12 even:bg-gray-100 bg-white">
						<td
							className="px-2 py-4 border-b-2 border-stone-400 bg-white border-r-2"
							colSpan={5}
						>
							<Button
								disabled={disabled}
								className={"p-4"}
								value={"Add"}
								onClick={() => {
									let combinedDataAndAddedData = [
										...addedData,
										...(data ? data : []),
									];
									if (
										combinedDataAndAddedData.length === doorSizesList.length
									) {
										setValidation({
											icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
											title: "Error",
											message: "Maximum number of door size is reached",
											open: true,
											actions: (
												<div className="grid grid-cols-1">
													<Button
														onClick={() => setValidation({ open: false })}
														value={"OK"}
														className={"p-2"}
													/>
												</div>
											),
										});
									} else {
										handleAddDataItem();
									}
								}}
							/>
						</td>
					</tr>
				</tbody>
			</table>
			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</div>
	);
}
